import { useEffect } from 'react'

import { Box, BoxProps } from '@mantine/core'
import cls from 'classnames'

type Props = {
  href: string
  layout?: number
} & BoxProps

export const ZaloSharing = ({
  href = '',
  layout = 2,
  className,
  ...rest
}: Props) => {
  useEffect(() => {
    const scriptId = 'zalo-script'
    const scriptEle = document.querySelector('#' + scriptId)

    if (scriptEle) {
      scriptEle.remove()
      // document.querySelector('.zalo-share-button')?.remove()
    }

    const script = document.createElement('script')
    script.setAttribute('id', 'zalo-script')
    script.src = 'https://sp.zalo.me/plugins/sdk.js'
    script.async = true
    document.head.appendChild(script)
  }, [])

  // TODO: instead, use js to mount the div outside of the react tree to prevent rerender
  return (
    <Box
      className={cls('zalo-share-button', className)}
      data-href={href}
      data-oaid="3186943975751313634"
      data-layout={layout}
      data-color="white"
      data-customize="false"
      {...rest}
    />
  )
}
